import {WidgetDetailedInfo} from "@wms/design-container";

export const deviceConfig: { [key: string]: WidgetDetailedInfo } = {
  'wm-camera':{
  "widgetType": "wm-camera",
    "template": "<wm-camera></wm-camera>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName":"camera"
},
  'wm-barcodescanner': {
  "widgetType": "wm-barcodescanner",
    "template": "<wm-barcodescanner></wm-barcodescanner>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName":"barcodescanner",
    styleWorkspaceTemplates: {
          "platforms": {
      "native_mobile": {
              customTemplate: [`<wm-barcodescanner name="barcodescanner1" caption="barcodecaption"></wm-barcodescanner>`], 
      }} 
    }
},
'wm-bottomsheet':{
  "widgetType": "wm-bottomsheet",
    "template": "<wm-bottomsheet></wm-bottomsheet>",
     "isContainer": true,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDeletable": true,
    "canBeCopied": false,
    "isDroppable": false,
    "tokenFileName":"bottomsheet",
    styleWorkspaceTemplates: {
customTemplate:[`<div style="position:relative; min-height: 425px">
          <wm-bottomsheet name="bottomsheet1" expand="true" showonrender="true"> <wm-label padding="unset" name="label2" variant="default:h5" class="h5"
            caption="Content of Bottom Sheet goes here"></wm-label></wm-bottomsheet>
          </div>`]
    }
},

};

export const deviceSubGroup = {
  'device': {
    "name": "device",
    "namekey": "LABEL_DEVICE_WIDGETS",
    "parent": "widgets",
    "feature": "components.device",
    "widgets": [
      {
        "widgetType": "wm-camera",
        "name": "Camera",
        "namekey": "LABEL_DEVICE_WIDGET_CAMERA",
        "iconclass": "camera",
        "apiDocLink": "classes/Camera.html",
        "widgetDocLink": "mobile-widgets/camera",
        "feature": "components.device.widgets.camera"
      },
      {
        "widgetType": "wm-barcodescanner",
        "name": "Barcode Scanner",
        "namekey": "LABEL_DEVICE_WIDGET_BARCODESCANNER",
        "iconclass": "barcode-scanner",
        "apiDocLink": "classes/Barcodescanner.html",
        "widgetDocLink": "mobile-widgets/barcode-scanner",
        "feature": "components.device.widgets.barcodeScanner"
      },
       {
        "widgetType": "wm-bottomsheet",
        "name": "Bottom Sheet",
        "namekey": "LABEL_DEVICE_WIDGET_BOTTOMSHEET",
        "iconclass": "bottomsheet",
        "apiDocLink": "classes/Barcodescanner.html",
        "widgetDocLink": "mobile-widgets/barcode-scanner",
        "feature": "components.device.widgets.bottomsheet"
      },
     
    ]
  }


}
